// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../js/node_modules/mini-css-extract-plugin/dist/loader.js!../js/node_modules/css-loader/index.js!../js/node_modules/clean-css-loader/lib/index.js!../js/node_modules/clean-css-loader/lib/index.js??ref--2-4!./tachyons.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../js/node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("8918c688", content, false, {});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../js/node_modules/mini-css-extract-plugin/dist/loader.js!../js/node_modules/css-loader/index.js!../js/node_modules/clean-css-loader/lib/index.js!../js/node_modules/clean-css-loader/lib/index.js??ref--2-4!./tachyons.css", function() {
     var newContent = require("!!../js/node_modules/mini-css-extract-plugin/dist/loader.js!../js/node_modules/css-loader/index.js!../js/node_modules/clean-css-loader/lib/index.js!../js/node_modules/clean-css-loader/lib/index.js??ref--2-4!./tachyons.css");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}